import React, { useState } from "react";
import style from "./style.module.scss";
import ReactModal from "react-modal";
import TextInput from "../../../../components/form/text-input";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import { copyApp, duplicateApp } from "../../../../../api";
import config from "../../../../../config";
import toast from "react-hot-toast";
import CloseIcon16 from "../../../../assets/svg/icons/common/CloseIcon16";
const MAIN_URL = config.paymentcloud.MAIN_URL;

const CopyApplication = ({
  isOpen,
  onClose,
  appData,
  loggedInUser,
  history,
  fetchApplication = null,
}) => {
  const [dbaName, setDbaName] = useState(
    appData?.field_dba ? appData?.field_dba : "",
  );
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    const payload = {
      editslug: appData?.editslug,
      stratus: true,
      ajaxRequest: true,
      new_dba: dbaName,
    };
    setIsLoading(true);
    const toastId = toast.loading("Duplicating application...");
    const response = await duplicateApp(payload);

    if (response.status) {
      toast.success("Application duplicated successfully!", { id: toastId });

      if (typeof fetchApplication === "function") {
        fetchApplication();
      }

      if (response?.app_version == 2) {
        history.push(`/app/${response.user_slug}/${response.editslug}`);
      } else {
        window.open(
          `${MAIN_URL}/${response.user_slug}/${response.editslug}`,
        );
      }
      setIsLoading(false);
      onClose();
    } else {
      toast.error(response?.msg || "Something went wrong!", { id: toastId });
      setIsLoading(false);
    }
  };

  return (
    <ReactModal
      isOpen={isOpen}
      className={style.react_modal}
      ariaHideApp={false}
    >
      <div className={style.header}>
        <ButtonIcon onClick={onClose}>
          <CloseIcon16 />
        </ButtonIcon>
      </div>

      <div className={style.body}>
        <h6>Copy Application</h6>

        <div className={style.form_group}>
          <TextInput
            id="dba"
            name="dba"
            label="DBA"
            value={dbaName}
            onChange={(e) => setDbaName(e.target.value)}
            placeholder="Enter DBA"
          />
        </div>
      </div>

      <div className={style.footer_modal}>
        <div className={style.button_group}>
          <ButtonIcon textColor="#254FE2" onClick={onClose}>
            Cancel
          </ButtonIcon>
          <ButtonIcon
            bgColor="#4C70EF"
            textColor="#FFF"
            isLoading={isLoading}
            disabled={!dbaName}
            onClick={handleSubmit}
          >
            Copy
          </ButtonIcon>
        </div>
      </div>
    </ReactModal>
  );
};

export default CopyApplication;
